// What the order picker and the plan page's order selector share: the
// client's units (centimetres, kilograms; the optimizer works in feet), the
// pallet an order starts with until it's sized, and the delivery-window
// choices.

export const CM_PER_FT = 30.48;

// A pallet as the client measures it.
export interface CmPallet {
  length_cm: number;
  width_cm: number;
  height_cm: number;
  weight_kg: number;
}

// What a pallet is until the dispatcher sizes it.
export const STD_PALLET_CM: CmPallet = {
  length_cm: 120,
  width_cm: 100,
  height_cm: 150,
  weight_kg: 100,
};

// The optimizer's pallet (feet, kg) in the client's units.
export function palletToCm(p: {
  length_ft: number;
  width_ft: number;
  height_ft: number;
  weight_kg: number;
}): CmPallet {
  return {
    length_cm: Math.round(p.length_ft * CM_PER_FT),
    width_cm: Math.round(p.width_ft * CM_PER_FT),
    height_cm: Math.round(p.height_ft * CM_PER_FT),
    weight_kg: Math.round(p.weight_kg * 10) / 10,
  };
}

// The client's pallet back in the optimizer's units, to a tenth of a foot.
export function palletToFt(p: CmPallet) {
  return {
    length_ft: +(p.length_cm / CM_PER_FT).toFixed(1),
    width_ft: +(p.width_cm / CM_PER_FT).toFixed(1),
    height_ft: +(p.height_cm / CM_PER_FT).toFixed(1),
    weight_kg: p.weight_kg,
  };
}

// Delivery-window choices — 30-min slots so a malformed time is impossible.
export const TIME_SLOTS = (() => {
  const out: string[] = [];
  for (let m = 6 * 60; m <= 20 * 60; m += 30) {
    const h = Math.floor(m / 60);
    out.push(`${String(h).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`);
  }
  return out; // "06:00" … "20:00"
})();
